import { SoapLive } from "./soapLive";
import { SoapShareNavigationSection } from "./soapShareNavigationSection";
import { SoapCountdown } from "./soapCountdown";


export class SoapInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new SoapLive();
        new SoapShareNavigationSection();
        new SoapCountdown();
    }
}
